// @intent: Single source of truth for known assetUrl values (allow-list, per OWASP LLM Top 10 2026 + Microsoft Agent Safety guidance)
// @flow: patchGate (validation/enforcement) + services/agent prompts (best-effort guardrail informing model) both import here
// @stale: when assets in apps/web/public/playable-assets/ change; W5.5 image pipeline will replace with server-injected dynamic list (BeNice CDN URLs)

export interface KnownAsset {
  readonly url: string;
  readonly description: string;
}

/** Asset list with descriptions — used by services/agent to inform the LLM in the system prompt */
export const KNOWN_ASSETS_LIST: readonly KnownAsset[] = [
  { url: '/playable-assets/cone.svg', description: 'ice-cream cone icon' },
  { url: '/playable-assets/tile-mint.svg', description: 'green tile sprite' },
  { url: '/playable-assets/tile-violet.svg', description: 'violet tile sprite' },
  { url: '/playable-assets/tile-amber.svg', description: 'amber/yellow tile sprite' },
  { url: '/playable-assets/tile-rose.svg', description: 'rose/pink tile sprite' },
  { url: '/playable-assets/hand.svg', description: 'tutorial pointer hand (match3 first-move hint)' },
];

/** URL Set for fast membership lookup in patchGate semantic stage */
export const KNOWN_ASSETS: ReadonlySet<string> = new Set(KNOWN_ASSETS_LIST.map((a) => a.url));
